module.exports = __webpack_public_path__ + "img/laboratoire.8d20dc79.png";